import router from 'router'
import store from 'vuex/store'
import {has} from 'lodash'

export default function (error) {
	if (error.response) {
		const statusCode = error.response.status
		let errorText = ''
		if (has(error, 'response.data.errors')) {
			errorText = JSON.stringify(error.response.data.errors)
		} else if (has(error, 'response.data.message')) {
			errorText = error.response.data.message
		} else if (has(error, 'response.data.messages')) {
			errorText = error.response.data.messages
		} else if (has(error, 'response.statusText')) {
			errorText = error.response.statusText
		} else {
			errorText = JSON.stringify(error.response)
		}

		switch (error.response.status) {
		case 401:
			localStorage.removeItem('access_token')
			localStorage.removeItem('token_type')
			store.commit('user/SET_USER', null)
			store.commit('user/SET_TOKEN', null)
			toastr['error'](errorText, `Ошибка ${statusCode}`)
			router.push({name: 'LoginPage'})
			break
		case 404:
			toastr['error'](errorText, `Ошибка ${statusCode}`)
			router.push('/404')
			break
		case 422:
			if (has(error, 'response.data.errors')) {
				if (typeof error.response.data.errors === 'object') {
					const obj = error.response.data.errors
					Object.keys(obj)
						.map(function (key) {
							const msg = obj[key]
							if (Array.isArray(msg)) {
								msg.map(str => toastr['error'](`${key}: ${str}`, `Ошибка ${statusCode}`))
							} else {
								toastr['error'](`${key}: ${msg}`, `Ошибка ${statusCode}`)
							}
						})
				} else {
					errorText = JSON.stringify(error.response.data.errors)
					toastr['error'](errorText, `Ошибка ${statusCode}`)
				}
			}
			break
		default:
			toastr['error'](errorText, `Ошибка ${statusCode}`)
		}
	} else {
		toastr['error'](error, 'Сервер не доступен')
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/functions/responseErrorHandler.js